import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export interface ItemsResponse<T> {
  items: T[]
  message?: string
}

export const getItemByPKAndPrefix = async <T = any>(
  PK: string,
  prefix: string = 'CREATION_TIMESTAMP_',
  limit: number = 1
): Promise<T[] | undefined> => {
  if (!PK || !prefix) return

  try {
    const url = `${baseUrl}/aws/query/${PK}?prefix=${prefix}&limit=${limit}`
    const response = await axios.get(url)
    if (response.status === 204) {
      return undefined
    }

    return response.data
  } catch (error) {
    console.error(`Error fetching item with PK=${PK} and prefix=${prefix}:`, error)
    return undefined
  }
}

export const useItemByPKAndPrefix = <T = any>(
  PK: string | undefined,
  prefix: string = 'CREATION_TIMESTAMP_',
  queryKey: (string | number | undefined)[] = ['item_by_pk', prefix, PK],
  limit: number = 1
): {
  data: T[] | undefined
  isLoading: boolean
  isError: boolean
} => {
  const { data, isLoading, isError }: UseQueryResult<T[] | undefined> = useQuery({
    queryKey,
    queryFn: () => getItemByPKAndPrefix<T>(PK!, prefix, limit),
    enabled: !!PK,
    staleTime: Infinity,
  })

  return {
    data,
    isLoading,
    isError,
  }
}

/*
const { data: organization, isLoading } = useItemByPKAndPrefix<Organization>(
  'ORG_abc123',
  'CREATION_TIMESTAMP_'
)


const { data: deals, isLoading } = useItemByPKAndPrefix<Deal[]>(
  'ORG_abc123',
  'DEAL_',
  ['deals_for_org', 'ORG_abc123'],
  100
)

*/
